import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'
import Login from '../components/cabinet/LoginPage'
import store from '../store'

Vue.use(VueRouter)

const mainChildren = [
  {
    path: '/employees', name: 'Employees',
    component: () => import('../components/employees/EmployeesTable')
  },
  {
    path: '/departments', name: 'Departments',
    component: () => import('../components/departments/DepartmentsTable')
  },
  {
    path: '/cabinet', name: 'Cabinet',
    component: () => import('../components/cabinet/Cabinet')
  },
  {
    path: '/wazzup', name: 'Wazzup',
    component: () => import('../views/Wazzup')
  },
]

const routes = [
  {
    path: '/', name: 'Index',
    components: {app: Home},
    children: mainChildren
  },
  {
    path: '/login', name: 'Login',
    components: {other: Login},
    meta: {
      AllowAny: true
    }
  },
  {
    path: "*", component: {template: '<v-app>asd</v-app>'},
    meta: {
      AllowAny: true
    }
  }
]

const router = new VueRouter({
  mode: "history",
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'Login' && !store.getters.isAuth) {
    next('/login')
    return
  }
  next()
})

export default router
